import { render, staticRenderFns } from "./UcSuggestContractOption.yaml?vue&type=template&id=4eaba2e4&component"
import script from "./UcSuggestContractOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestContractOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports